import { Modal as MuiModal } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledModal = styled(MuiModal)(({ theme }) => {
  const contentWidth = "28rem";
  const modalWidth = "34rem";
  const borderRadius = "1rem";
  return {

    backgroundColor: theme.customColors.backgroundCard,
    borderRadius,
    boxShadow: "24px",
    height: "fit-content",
    left: "50%",
    maxHeight: "90vh",
    overflow: "auto",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: modalWidth,
    zIndex: 1450,

    ".MuiModal-backdrop":{
      backdropFilter:"none",
      background: theme.customColors.backgroundCard,
      border: `2px solid ${theme.customColors.border}`,
      borderRadius
    },

    "p": {
      maxWidth: contentWidth,
      overflowWrap:"break-word"
    }
  };});
